const translations = {
  "en": {
    "Score": "Score"
  },
  "zh-tw": {
    "Score": "分數"
  }
};

export default translations;
